const TailwindScreens = {
  'xs': '(min-width: 460px)', // 28.75em
  'sm': '(min-width: 640px)', // 40em
  'md': '(min-width: 768px)', // 48em
  'lg': '(min-width: 1024px)', // 64em
  'xl': '(min-width: 1280px)', // 80em
  '2xl': '(min-width: 1536px)', // 96em,
  'container': '(min-width: 1336px)' // 83.5em
}
export const TailwindScreensEM = {
  'xs': '28.75em', // 460px
  'sm': '(min-width: 40em)', // 40em
  'md': '(min-width: 48em)', // 48em
  'lg': '(min-width: 64em)', // 64em
  'xl': '(min-width: 80em)', // 80em
  '2xl': '(min-width: 96em)', // 96em
  'container': '(min-width: 83.5em)' // 83.5em
}
export const TailwindScreensEMValues = {
  'xs': 28.75, // 460px
  'sm': 40, // 40em
  'md': 48, // 48em
  'lg': 64, // 64em
  'xl': 80, // 80em
  '2xl': 96, // 96em
  'container': 83.5 // 83.5em
}
export const TailwindScreensKeys = ['xs', 'sm', 'md', 'lg', 'xl', '2xl']

export default TailwindScreens
